const CLASS_HOLD = 'comment-highlight-anchor'
const CLASS_FADE = 'comment-highlight-anchor--fading'

/** 稳定高亮保持时长（毫秒） */
const HOLD_MS = 2000
/** 与 global.css 中淡出 transition 时长一致，并留少量余量再移除类 */
const FADE_MS = 900

/**
 * 定位到评论节点后的高亮：先稳定高亮约 2 秒，再缓慢过渡消失（无闪烁）
 */
export function flashHighlightElement(el) {
  if (!el || !el.classList) return
  el.classList.remove(CLASS_HOLD, CLASS_FADE)
  void el.offsetWidth
  el.classList.add(CLASS_HOLD)

  window.setTimeout(() => {
    if (!el.classList || !el.classList.contains(CLASS_HOLD)) return
    el.classList.add(CLASS_FADE)
  }, HOLD_MS)

  window.setTimeout(() => {
    el.classList.remove(CLASS_HOLD, CLASS_FADE)
  }, HOLD_MS + FADE_MS)
}
